<script>
  import {getContext, onMount} from 'svelte';
  import {combineLatest} from 'rxjs';
  import { stores} from '@sapper/app';
  import {map} from 'rxjs/operators';
  import {numUtil} from '@/helper/num';
  import Register from '@/modules/register/componets/Register.svelte';
  import {bonusCurrency$, bonusStages$, kolInfo$, maxBonus$, query$} from './stream';
  import UserBanner from './componets/UserBanner.svelte';
  import LogoUser from './componets/LogoUser.svelte';
  import BonusBars from './componets/BonusBars.svelte';
  import Conditions from './componets/Conditions.svelte';
  import lang from './KolExclusiveRegister.lang';

  const LG = getContext('LG');
  const {page} = stores();
  const bars$ = combineLatest([bonusCurrency$, bonusStages$]).pipe(
    map(([currency, list]) => {
      return list.map(({bonus, trade, deposit}) => {
        return {
          title: `${numUtil.delimit(bonus)} ${currency}`,
          desc: `${LG(lang.Deposit)} ${formatNumber(deposit)} & ${LG(lang.Trade)} ${formatNumber(trade)}`,
          value: bonus,
        };
      });
    })
  );

  onMount(() => {
    const {query} = $page;
    query$.next(query.referralCode);
  });

  function formatNumber(val) {
    if (val >= 1e6) {
      return Math.round(val / 1e6) + 'M';
    }
    if (val >= 1e3) {
      return Math.round(val / 1e3) + 'K';
    }
    return val;
  }
</script>

<style>
  .register-container {
    border-radius: 12px;
    padding: 40px;
    background: #fff;
  }
  .register-main {
    padding-bottom: 40px;
    width: 100%;
    min-width: 1280px;
    min-height: calc(100vh - 40px);
    background: #010612;
    color: #fff;
  }
  .register-main .inner {
    display: flex;
    margin: 0 auto;
    padding-top: 40px;
    width: 1280px;
    gap: 80px;
  }
  @media screen and (max-width: 640px) {
    .register-main {
      display: block;
      min-width: 100%;
    }
    .register-main .inner {
      flex-direction: column;
      width: 92%;
      gap: 20px;
    }
  }
</style>

{#if $kolInfo$ && $kolInfo$.name}
  <div class="register-main">
    <div class="inner">
      <div class="f1">
        <LogoUser user={$kolInfo$.name} />
        <UserBanner title={$kolInfo$.name} avatar={$kolInfo$.avatar} desc={LG(lang.JoinMe, {Bonus: "<span class='fw3'>" + $maxBonus$ + '</span>'})} />
        <BonusBars title={$maxBonus$} desc={LG(lang.BonusName)} bars={$bars$} />
        <Conditions />
      </div>
      <div class="register-container">
        <Register />
      </div>
    </div>
  </div>
{/if}
